var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.372 20.413c-.808-2.21-.226-6.518 1.024-8.565 2.454-4.021 5.365-3.89 6.718-3.83l.123.005c.088.004.19.006.306.009 1.57.033 5.41.114 5.511 4.732.108 4.955-1.293 8.78-5.817 10.072-4.525 1.293-7.203-.614-7.865-2.424zm3.986-4.687c.69-2.8 2.011-4.076 2.586-4.363 1.203-.467 3.469-.506 2.909 3.07-.7 4.471-2.91 5.495-4.04 5.495-1.131 0-2.316-.7-1.455-4.202zm14.975 7.272h-3.878l3.34-14.92h7.54a4.776 4.776 0 0 1 3.663 4.632c.087 3.102-3.088 4.704-4.686 5.117H21.68l-1.347 5.17zm1.885-8.295.754-3.502h2.747c.377.002 1.141.282 1.184 1.402.044 1.12-1.13 1.867-1.723 2.1h-2.962z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOp);
export default __webpack_public_path__ + "static/media/OP.2b4f23be12c7379179be0193d28878e3.svg";
export { ForwardRef as ReactComponent };